import React from "react";
import { strings } from "../../../../../common/i18n";
import Reject from "../../AuditAsset/Reject";
import { Dialog } from "@mui/material/";
import useColumnsRows from "./useColumnsRows";
import MatReactTable from "../../../../../common/components/MaterialReactTable";
import ExcludeAsset from "./ExcludeAsset";
import ResolveAsset from "./ResolveAsset";
import MatchDrawer from "./MatchDrawer";
import MoveAsset from "./MoveAsset";
import Loading from "../../../../../common/components/Loading";

/**
 * Audit Summary Table Component
 */
export default () => {
    const {
        condition,
        loading,
        setLoading,
        rowActions,
        columns,
        data,
        getRowClassName,
        rejectDialogOpen,
        onEdit,
        onChangeState,
        onRejectDialogHide,
        excludeDialogOpen,
        onExcludeDialogOpen,
        onExcludeDialogClose,
        moveAssetDialogOpen,
        onMoveAssetDialogClose,
        resolveDialogOpen,
        onResolveDialogOpen,
        onResolveDialogClose,
        onRejectSubmit,
        selectedAssets,
        toolBarComponents,
        currentRow,
        assetMatchDrawerOpen,
        setAssetMatchDrawerOpen
    } = useColumnsRows();

    if (loading) return <Loading loadingText={"updatingAsset"} />;
    return (
        <>
            <MatReactTable
                columns={columns}
                onRowClick={onEdit}
                data={data}
                loading={loading}
                rowSelection={true}
                // Bulk approve/reject act on the selection, so select-all must
                // cover every filtered asset, not just the visible page.
                selectAllMode="all"
                rowActions={rowActions}
                toolBarComponents={toolBarComponents}
                noRowsMessage={strings("messages.noAssets")}
                persistKey={`review:${condition}`}
                enableRowVirtualization
                initialState={{
                    pagination: {
                        pageSize: data.length > 0
                            ? ([50, 100, 250, 500].find((s) => s >= data.length) ?? 500)
                            : 50,
                        pageIndex: 0
                    }
                }}
            />

<>
                <Dialog onClose={onRejectDialogHide} open={!!rejectDialogOpen}>
                    <Reject
                        onClose={onRejectDialogHide}
                        onSubmit={onRejectSubmit}
                        readonly={loading}
                    />
                </Dialog>
                <Dialog
                    onClose={onExcludeDialogClose}
                    open={!!excludeDialogOpen}
                >
                    <ExcludeAsset
                        setLoading={setLoading}
                        selectedAssets={selectedAssets}
                        onOpen={onExcludeDialogOpen}
                        onClose={onExcludeDialogClose}
                    />
                </Dialog>
                <Dialog
                    onClose={onMoveAssetDialogClose}
                    open={!!moveAssetDialogOpen}
                >
                    <MoveAsset
                        selectedAssets={selectedAssets}
                        onOpen={moveAssetDialogOpen}
                        onClose={onMoveAssetDialogClose}
                    />
                </Dialog>
            </>

            <>
                <Dialog
                    onClose={onResolveDialogClose}
                    open={!!resolveDialogOpen}
                >
                    <ResolveAsset
                        selectedAssets={selectedAssets}
                        onOpen={onResolveDialogOpen}
                        onClose={onResolveDialogClose}
                    />
                </Dialog>

                <MatchDrawer
                    open={assetMatchDrawerOpen}
                    onClose={() => setAssetMatchDrawerOpen(false)}
                    asset={currentRow} // assumes a single asset selected
                    onConfirmMatch={(asset, match) => {
                        // Dispatch action or API call here
                        // console.log(
                        //     "Confirmed match",
                        //     match,
                        //     "for asset",
                        //     asset
                        // );
                    }}
                />
            </>
        </>
    );
};
